import React from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { useTranslation } from "react-i18next";
import {
  AdsClickRounded,
  CalendarMonthRounded,
  GroupsRounded,
  ScheduleRounded,
  SmartphoneRounded,
  PsychologyRounded,
  MedicationRounded,
  MonitorHeartRounded,
  PeopleRounded,
  SchoolRounded,
} from "@mui/icons-material";

const facilityFeatures = [
  {
    icon: <ScheduleRounded color="primary" />,
    textKey: "pricing.features.facility.waitingRoomVolume",
  },
  {
    icon: <CalendarMonthRounded color="primary" />,
    textKey: "pricing.features.facility.scheduleVolume",
  },
  // TODO: Re-enable once Twilio BAA is in place
  // { icon: <GroupsRounded color="primary" />, text: "Manage your virtual queue" },
  // { icon: <SmartphoneRounded color="primary" />, text: "Send your patients a text when you're ready to see them" },
];

const patientFeatures = [
  {
    icon: <PsychologyRounded color="primary" />,
    textKey: "pricing.features.patient.explore",
  },
  {
    icon: <MonitorHeartRounded color="primary" />,
    textKey: "pricing.features.patient.overviews",
  },
  {
    icon: <MedicationRounded color="primary" />,
    textKey: "pricing.features.patient.medications",
  },
];

const professionalFeatures = [
  {
    icon: <PeopleRounded color="primary" />,
    textKey: "pricing.features.professional.caseReview",
  },
  {
    icon: <SchoolRounded color="primary" />,
    textKey: "pricing.features.professional.clinicalSupport",
  },
  {
    icon: <PsychologyRounded color="primary" />,
    textKey: "pricing.features.professional.complexCases",
  },
];

export const getFeaturesForRole = (role) => {
  switch (role) {
    case "patient":
      return patientFeatures;
    case "professional":
      return professionalFeatures;
    default:
      return facilityFeatures;
  }
};

const UpgradeFeatures = ({ role, dense = false, sx }) => {
  const { t } = useTranslation("home");
  const features = getFeaturesForRole(role);

  return (
    <List dense={dense} sx={{ mb: 2, ...sx }}>
      {features.map((feature, index) => (
        <ListItem key={index}>
          <ListItemIcon>{feature.icon}</ListItemIcon>
          <ListItemText primary={t(feature.textKey)} />
        </ListItem>
      ))}
    </List>
  );
};

export default UpgradeFeatures;
